import * as React from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {Link, Section} from 'components/UIKit';
import {ListingCards} from 'components/Marketplace/ListingCards';
import {FeaturedSection} from '../../types';
import styles from '../../Home.scss';
import * as locales from './locales';

export interface FeaturedListingsProps {
  feature: FeaturedSection;
  index: number;
}

function FeaturedListingsComponent({feature, index, i18n}: FeaturedListingsProps & WithI18nProps) {
  return (
    <>
      <Section
        heading={i18n.translate(`${feature.key}.heading`)}
        subhead={i18n.translate(`${feature.key}.subhead`)}
        className={index % 2 === 0 && styles.BackgroundSilverLight}
        headingProps={{align: 'center'}}
        subheadProps={{align: 'center'}}
        headerSpacing="small"
      >
        <ListingCards group={feature.key} shops={feature.shops} />
        <Link
          url={feature.linkUrl}
          text={i18n.translate('SeeMore', {shopCount: feature.count})}
          forcePink
        />
      </Section>
    </>
  );
}

export const FeaturedListings = withI18n({
  id: 'FeaturedListings',
  fallback: locales.en,
})(FeaturedListingsComponent);
